module.exports = __webpack_public_path__ + "img/M2_MS_29.b05c9821.png";